export type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

export default function SaveStatusBanner({ status }: { status: SaveStatus }) {
  if (status === 'idle') return null;

  if (status === 'saving') {
    return (
      <div className="mb-4 flex items-center gap-2 text-sm text-foreground-500 bg-background-100 border border-background-200 rounded-lg px-4 py-2.5">
        <i className="ri-loader-4-line animate-spin"></i>
        검사 결과를 저장하는 중...
      </div>
    );
  }

  if (status === 'saved') {
    return (
      <div className="mb-4 flex items-center gap-2 text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-4 py-2.5">
        <i className="ri-checkbox-circle-line"></i>
        검사 결과가 저장되었습니다. 대시보드 &gt; 내 검사결과에서 확인하고 인쇄할 수 있어요.
      </div>
    );
  }

  return (
    <div className="mb-4 flex items-start gap-2 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-4 py-2.5">
      <i className="ri-error-warning-line mt-0.5"></i>
      <span>
        검사 결과를 저장하지 못했습니다. 네트워크 상태를 확인한 뒤 다시 검사해주세요.
      </span>
    </div>
  );
}